export const paginate = (totalPages: number, currentPage: number): number[] => {
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    return pages.filter(page => {
        return page < 3 || page > pages.length - 2 || (page > currentPage - 3 && page < currentPage + 3)
    })
}
